/** Shared Accounting destinations above the selected area's existing section navigation. */
import type { ComponentProps } from 'react';
import { SidebarGroup, SidebarGroupContent, SidebarMenu, SidebarMenuButton, SidebarMenuItem } from '../../shared/ui/sidebar';
import { Separator } from '../../shared/ui/separator';
import { cn } from '../../shared/ui/utils';
import { accountingAreaItems, type AccountingDestination } from './sidebarNavConfig';

interface AccountingSectionNavigationProps {
  labelled?: boolean;
  currentView: string;
  destinations: readonly AccountingDestination[];
  onNavigate: (view: string) => void;
  onSelected: () => void;
  rowClassName: string;
  iconClassName: string;
  iconWrapClassName: string;
  menuClassName: string;
  tooltip: (label: string) => ComponentProps<typeof SidebarMenuButton>['tooltip'];
}

export function AccountingSectionNavigation({ currentView, destinations, onNavigate, onSelected,
  rowClassName, iconClassName, iconWrapClassName, menuClassName, tooltip, labelled = false,
}: AccountingSectionNavigationProps) {
  return (
    <SidebarGroup className="p-0 shrink-0" aria-label="Accounting areas">
      <SidebarGroupContent>
        <SidebarMenu className={menuClassName}>
          {accountingAreaItems(destinations).map(({ id, label, icon: Icon }) => {
            const active = currentView === id;
            return <SidebarMenuItem key={id}>
              <SidebarMenuButton isActive={active} aria-current={active ? 'page' : undefined}
                data-section-rail-item={labelled || undefined}
                tooltip={tooltip(label)} className={rowClassName}
                onClick={() => { onNavigate(id); onSelected(); }}>
                <div className={cn('relative w-[28px] shrink-0 flex items-center justify-center', iconWrapClassName)}>
                  <Icon className={cn(iconClassName, 'shrink-0 transition-colors', active
                    ? 'text-nav-item-active-text' : 'text-nav-item-text group-hover:text-nav-item-text-hover')} />
                </div>
                <span data-slot="section-rail-label" className="truncate">{label}</span>
              </SidebarMenuButton>
            </SidebarMenuItem>;
          })}
        </SidebarMenu>
        <Separator className="my-3 bg-nav-item-text/15" />
      </SidebarGroupContent>
    </SidebarGroup>
  );
}
